import { ROUTES } from '../../../shared/config/routes';
import { CHANNEL } from '../../../features/templates/constants/messageTemplateKeys';

export function getCreateTemplatePageConfig(pathname = '') {
  const normalizedPath = String(pathname ?? '');
  const isEditMode = normalizedPath.includes('/templates/edit/');
  const isSms =
    normalizedPath === ROUTES.TEMPLATES_CREATE_SMS ||
    normalizedPath.includes('/templates/edit/sms/');
  const isMms =
    normalizedPath === ROUTES.TEMPLATES_CREATE_MMS ||
    normalizedPath.includes('/templates/edit/mms/');
  const channelKey = isSms ? CHANNEL.SMS : isMms ? CHANNEL.MMS : CHANNEL.EMAIL;
  const channelLabel = isSms ? 'SMS' : isMms ? 'MMS' : 'Email';

  return {
    channelKey,
    channelLabel,
    isEditMode,
    pageTitle: `${isEditMode ? 'Edit' : 'Create'} ${channelLabel} Template`,
  };
}
